module.exports = __webpack_public_path__ + "img/4-01-06-first-telephone.1ac93914.svg";